import React from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";

const AdBanner = ({ placement = "in_content", format = "horizontal" }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.between('md', 'lg'));
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const isDev = process.env.NODE_ENV === 'development';

  // No mostrar ads a admins/editores (solo en producción)
  if (!isDev && (user?.profile?.role === "admin" || user?.profile?.role === "editor" || user?.is_superuser))
    return null;
  
  // No mostrar ads verticales/rectangulares en móvil
  if (isMobile && (format === "sidebar" || format === "vertical" || format === "rectangle")) 
    return null;

  // Dimensiones responsivas según formato y dispositivo
  const getDimensions = () => {
    if (isMobile) {
      return {
        horizontal: { height: '100px', width: '100%', maxWidth: '100%' },
        square: { height: '250px', width: '250px', maxWidth: '100%' },
      };
    }
    
    if (isTablet) {
      return {
        horizontal: { height: '100px', width: '100%', maxWidth: '100%' },
        vertical: { height: '500px', width: '250px', maxWidth: '100%' },
        square: { height: '250px', width: '250px', maxWidth: '100%' },
        rectangle: { height: '250px', width: '300px', maxWidth: '100%' },
      };
    }

    // Desktop
    return {
      horizontal: { height: '120px', width: '100%', maxWidth: '100%' },
      vertical: { height: '600px', width: '300px', maxWidth: '100%' },
      square: { height: '300px', width: '300px', maxWidth: '100%' },
      rectangle: { height: '250px', width: '300px', maxWidth: '100%' },
    };
  };

  const dimensions = getDimensions();
  const isDark = theme.palette.mode === 'dark';

  return (
    <div style={{
      border:`2px dashed ${isDark?'#00F5FF':'#FF3FA3'}`,
      padding:20,textAlign:'center',
      background:isDark?'rgba(0,245,255,.05)':'rgba(255,63,163,.05)',
      borderRadius:12
    }}>
      <span className="glitch" style={{fontSize:'0.8rem',color:isDark?'#00F5FF':'#FF3FA3'}}>PUBLICIDAD</span>
      <p style={{margin:0,color:isDark?'#A0A0A0':'#4A4A4A'}}>Espacio publicitario</p>
    </div>
  );
};

export default AdBanner;

